const STATIC_BLOOD_GROUP_OPTIONS = Object.freeze([
  { id: "1", name: "A+", display_label: "A+" },
  { id: "2", name: "A-", display_label: "A-" },
  { id: "3", name: "B+", display_label: "B+" },
  { id: "4", name: "B-", display_label: "B-" },
  { id: "5", name: "AB+", display_label: "AB+" },
  { id: "6", name: "AB-", display_label: "AB-" },
  { id: "7", name: "O+", display_label: "O+" },
  { id: "8", name: "O-", display_label: "O-" },
  { id: "9", name: "Do Not Know", display_label: "Do Not Know" },
]);

export function getStaticBloodGroupOptions() {
  return STATIC_BLOOD_GROUP_OPTIONS.map((option) => ({ ...option }));
}

export default STATIC_BLOOD_GROUP_OPTIONS;
